import { getInterview } from '@/api/interviews';
import { useApiQuery } from '@/hooks/api';
import { REFERENCE_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { AppNavigate } from '@/hooks/useUrlState';
import type { InterviewRoom } from '@/types/interview';

export function useInterview(
  interviewId: string | null | undefined,
  options?: { enabled?: boolean; navigate?: AppNavigate },
) {
  const navigate = options?.navigate;

  return useApiQuery<InterviewRoom | null>({
    queryKey: queryKeys.interviews.detail(interviewId ?? ''),
    queryFn: async () => {
      if (!interviewId) return null;
      const res = await getInterview(interviewId, navigate);
      return res ?? null;
    },
    enabled: Boolean(interviewId) && (options?.enabled ?? true),
    staleTime: REFERENCE_STALE_TIME,
  });
}
